module.exports = __webpack_public_path__ + "media/images/lb/396-7b0a0bd0611c088ab11a8498cc862c22.svg";